import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getCargoItems(companyId, cargoId) {
	return dataTransferWrap(
		ModulesMap.CARGO_ITEMS,
		dtConfig[ModulesMap.CARGO_ITEMS].getCargoItems,
		{
			urlParams: {
				companyId,
				cargoId,
			},
		}
	)
}

function getCargoItem(companyId, cargoId, cargoItemId) {
	return dataTransferWrap(
		ModulesMap.CARGO_ITEMS,
		dtConfig[ModulesMap.CARGO_ITEMS].getCargoItem,
		{
			urlParams: {
				companyId,
				cargoId,
				cargoItemId,
			},
		}
	)
}

function createCargoItem(companyId, cargoId, payload) {
	return dataTransferWrap(
		ModulesMap.CARGO_ITEMS,
		dtConfig[ModulesMap.CARGO_ITEMS].createCargoItem,
		{
			urlParams: {
				companyId,
				cargoId,
			},
			...payload,
		}
	)
}


function putCargoItem(companyId, cargoId, cargoItemId, payload) {
	return dataTransferWrap(
		ModulesMap.CARGO_ITEMS,
		dtConfig[ModulesMap.CARGO_ITEMS].putCargoItem,
		{
			urlParams: {
				companyId,
				cargoId,
				cargoItemId,
			},
			...payload,
		}
	)
}

function patchCargoItem(companyId, cargoId, cargoItemId, payload) {
	return dataTransferWrap(
		ModulesMap.CARGO_ITEMS,
		dtConfig[ModulesMap.CARGO_ITEMS].patchCargoItem,
		{
			urlParams: {
				companyId,
				cargoId,
				cargoItemId,
			},
			...payload,
		}
	)
}

function deleteCargoItem(companyId, cargoId, cargoItemId) {
	return dataTransferWrap(
		ModulesMap.CARGO_ITEMS,
		dtConfig[ModulesMap.CARGO_ITEMS].deleteCargoItem,
		{
			urlParams: {
				companyId,
				cargoId,
				cargoItemId,
			},
		}
	)
}

function getCargoItemPreview(companyId, cargoId, cargoItemId) {
	return dataTransferWrap(
		ModulesMap.CARGO_ITEMS,
		dtConfig[ModulesMap.CARGO_ITEMS].getCargoItemPreview,
		{
			urlParams: {
				companyId,
				cargoId,
				cargoItemId,
			},
		}
	)
}

function getCargoItemPopup(companyId, cargoId, cargoItemId) {
	return dataTransferWrap(
		ModulesMap.CARGO_ITEMS,
		dtConfig[ModulesMap.CARGO_ITEMS].getCargoItemPopup,
		{
			urlParams: {
				companyId,
				cargoId,
				cargoItemId,
			},
		}
	)
}

export default {
	getCargoItems,
	getCargoItem,
	createCargoItem,
	putCargoItem,
	patchCargoItem,
	deleteCargoItem,
	getCargoItemPreview,
	getCargoItemPopup,
}

